import {Injectable} from '@angular/core';
import {ApiV2Service} from '../../../api-v2';
import {Observable} from 'rxjs';
import {ClusterInstanceTypeRecord} from './cluster.instance-type.vocabulary.model';

@Injectable({
  providedIn: 'root'
})
export class ClusterInstanceTypesVocabularyService {
  private readonly RESOURCE_BASE = '/vocabulary/cluster/instance-types';

  constructor(
    private readonly api: ApiV2Service
  ) {
  }

  /**
   * Retrieves all cluster instance types
   *
   * @returns Observable of cluster instance types
   */
  public getAll(): Observable<ClusterInstanceTypeRecord[]> {
    return this.api.get<ClusterInstanceTypeRecord[]>(this.RESOURCE_BASE);
  }


}
